module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f073f9_logo_200x200.61475163.png";